var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_c('b',[_vm._v(_vm._s(_vm.employee.firstName)+" "+_vm._s(_vm.employee.lastName))])]),_c('div',[_c('vue-table-dynamic',{attrs:{"params":_vm.params},on:{"cell-click":_vm.tableCellClicked}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }